import { Component, Input, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

/*##################################################################################*
 * COMPOSANT SPRO : spro-input-int
 *
 * DESCRIPTION : Composant de saisie d'un nombre entier
 *
 ##################################################################################*/

const noop = () => {};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => spro_cls_input_int),
  multi: true
};

@Component({
  selector: "spro-input-int",
  styleUrls: ["./spro-input-int.component.scss"],
  template: `
    <kendo-textbox-container
      [floatingLabel]="w_label | translate"
      class="autosize-kendo"
    >
      <kendo-numerictextbox
        [spinners]="f_spin"
        [(ngModel)]="value"
        (blur)="onBlur()"
        [class]="w_class"
        [format]="'n0'"
        [step]="1"
        [min]="0"
        [value]="value"
        [disabled]="!f_actif"
      >
      </kendo-numerictextbox>
    </kendo-textbox-container>
  `,
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class spro_cls_input_int {
  /** Libellé du composant */
  @Input() w_label: string;
  /** Affichage des boutons pour augmenter/baisser la valeur */
  @Input() f_spin?: Boolean = false;
  /** Pour désactiver la saisie */
  @Input() f_actif: boolean = true;
  /** Label contenant la classe utilisé pour le style de la zone */
  @Input() w_class: string = "form-control input-lg";

  /*################################################################################
    ###################   Necessaire a la gestion du ng Model ######################
    ################################################################################*/

  public w_innerValue: any = "";

  //Placeholders for the callbacks which are later provided
  //by the Control Value Accessor
  public proc_onTouchedCallback: () => void = noop;
  public proc_onChangeCallback: (_: any) => void = noop;

  /**
   * get accessor
   */
  get value(): any {
    return this.w_innerValue;
  }

  /**
   * set accessor including call the onchange callback
   */
  set value(v: any) {
    if (v !== this.w_innerValue) {
      this.w_innerValue = v;
      this.proc_onChangeCallback(v);
    }
  }

  /**
   * Set touched on blur
   */
  onBlur() {
    this.proc_onTouchedCallback();
  }

  /**
   * From ControlValueAccessor interface
   */
  writeValue(value: any) {
    if (value !== this.w_innerValue) this.w_innerValue = value;
  }

  /**
   * From ControlValueAccessor interface
   */
  registerOnChange(fn: any) {
    this.proc_onChangeCallback = fn;
  }

  /**
   * From ControlValueAccessor interface
   */
  registerOnTouched(fn: any) {
    this.proc_onTouchedCallback = fn;
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/inputs/spro-input-int/spro-input-int.component.ts